import Image from "next/image"
import styled, { css } from "styled-components"

const circleStyle = css<{
  $height: number
}>`
  overflow: hidden;
  position: relative;
  border-radius: 400px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  width: ${(p) => `${p.$height}px`};
  height: ${(p) => `${p.$height}px`};
  padding: 0px;
`

const StyledCircleButton = styled.button<{
  $height: number
}>`
  ${circleStyle}
`
const StyledCircleDiv = styled.div<{
  $height: number
}>`
  ${circleStyle}
`

const ImageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

type ColorCircleProps = {
  height?: number
  className?: string
  hex?: string
  imageUrl: string
  additionalPrice?: boolean
  disableButton?: boolean
  onClick?: any
}

const ColorCircle = ({
  height = 85,
  className,
  imageUrl,
  additionalPrice,
  disableButton,
  onClick,
}: ColorCircleProps) => {
  // set StyledCircle to be a button or a div react component
  const StyledCircle: React.ElementType = disableButton
    ? StyledCircleDiv
    : StyledCircleButton

  return (
    <StyledCircle className={className} $height={height} onClick={onClick}>
      {imageUrl && imageUrl !== "" && (
        <ImageWrap>
          <Image
            src={imageUrl}
            alt={additionalPrice ? "בתוספת מחיר" : `color Backround`}
            width={height}
            height={height}
            style={{
              maxWidth: "100%",
              height: "auto",
              objectFit: "cover"
            }} />
        </ImageWrap>
      )}
    </StyledCircle>
  );
}

export default ColorCircle
